import React from 'react';

const FotoAnimal = ({ product }) => {
    console.log(product)
  return (
    <div>
      <img
              src={
                product.FOTO && product.FOTO.startsWith('https')
                  ? product.FOTO
                  : 'https://www.ancogenecop.com/APIANCO/documentos/sin-foto.jpg'
              }
              alt="Foto del animal"
              style={{ width: '60px', height: '60px', objectFit: 'cover', borderRadius: '8px' }}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = 'https://www.ancogenecop.com/APIANCO/documentos/sinFoto.png';
              }}
        />
    </div>
  );
};

export default FotoAnimal;